import React, { useState, useEffect } from "react";

export default function SparePart() {
  const [data, setData] = useState([]);
  const [localStorageData, setLocalStorageData] = useState([]);

  const handleClick = () => {
    fetchSpareParts();
  };

  const fetchSpareParts = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/watchToTest/9999`,
        //'/api/v1/WatchHunter/Watches/Search',
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setData(payload);
      console.log("Payload : ", payload);
      localStorage.setItem("Data", JSON.stringify(payload));
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("Data") === "[]") {
      localStorage.setItem("Data", JSON.stringify(data));
    }
  }, [data]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("Data"));
    if (items) {
      setLocalStorageData(items);
    }
  }, [data]);
  const handleLocalStorageWriteData = () => {
    setLocalStorageData(JSON.parse(localStorage.getItem("Data")));
  };
  return (
    <div>
      <button onClick={handleClick}>log api data</button>
      <button onClick={handleLocalStorageWriteData}>
        write local storage data
      </button>
      <p>{JSON.stringify(localStorageData)}</p>
    </div>
  );
}
